import Vue from 'vue'
import VueRouter from 'vue-router'
import routes from "./route"

Vue.use(VueRouter)


const router = new VueRouter({
  routes,
  scrollBehavior (to, from, savedPosition) {
    let flag = true
    let rootList = ['aboutUs']
    rootList.forEach(root => {
      if(to.fullPath.includes(root) && from.fullPath.includes(root)){
        flag = false
      }
    })
    if(flag){
      return { x: 0, y: 0 }
    }
  }
})

export default router
